import React, {useState, useRef} from 'react';
import {Translation, getI18n} from 'react-i18next';
import {Form, Input, Popover, Typography, Space} from 'antd';
import {CheckCircleFilled, CloseCircleOutlined} from '@ant-design/icons';
import NumberFormat from 'react-number-format';


const rePostalCode = new RegExp('^\\d{5}$');

const incompleteTextType = 'default';
const incompleteIcon = <CloseCircleOutlined style={{ color: '#00000040' }} />;

const completeTextType = 'secondary';
const completeIcon = <CheckCircleFilled style={{ color: '#52c41a' }} />;

const PostalCodeInput = ({name, hasError=false, label=null, rules=null, disabled=false, autoFocus=false, useTooltip=true, tooltipPlacement='right', useSuccess=true, ...props}) => {

  const [isVisible, setIsVisible] = useState(false);

  const [isPostalCodeComplete, setIsPostalCodeComplete] = useState(false);

  const inputRef = useRef(null);

  const onChange = e => {
    const val = e.target.value;

    // check looks like postal code
    setIsPostalCodeComplete(rePostalCode.test(val.replace(/\D/g, '')));
  }

  const validatePostalCode = (rule, value) => {
    if (value) {
      const val = value.replace(/\D/g, '');
      if (val && !rePostalCode.test(val)) {
        return Promise.reject(getI18n().t('feedback_validation_postal_code'));
      } else {
        return Promise.resolve();
      }
    } else {
      return Promise.resolve();
    }
  }

  return (
    <Translation>{(t) =>
      <div className="form-group">
        <Popover
          placement={tooltipPlacement}
          trigger="focus"
          title={null}
          visible={useTooltip && isVisible && !isPostalCodeComplete}
          content={
            <>
              <Space direction="vertical">

                <Typography.Text
                  type={isPostalCodeComplete ? completeTextType : incompleteTextType}
                >
                  {isPostalCodeComplete ? completeIcon : incompleteIcon}{' '}
                  {t('input_requirment_postal_code')}
                </Typography.Text>

              </Space>
            </>
          }
        >
          <Form.Item
            name={name}
            label={label ? label : t('register_input_postal_code')}
            rules={rules
              ? rules
              : [
                  {required: true, message: t('feedback_validation_required')},
                  {validator: validatePostalCode}
                ]}
            // hasFeedback={useSuccess && isPostalCodeComplete && !hasError}
            hasFeedback={true}
            validateStatus={hasError ? "error" : (useSuccess && isPostalCodeComplete ? "success" : null)}
          >
            <NumberFormat
              customInput={Input}
              // placeholder="#####"
              format="#####"
              mask={['#', '#', '#', '#', '#']}
              disabled={disabled}
              autoFocus={autoFocus}
              onChange={onChange}
              ref={inputRef}
              onFocus={() => setIsVisible(true)}
              onBlur={() => setIsVisible(false)}
            />
          </Form.Item>
        </Popover>
      </div>
    }</Translation>
  )
}

export default PostalCodeInput;
